module.exports = "/_next/static/images/game-1-phone-gallery-08-25-1730-17dd5e495b2e5a8d8e3200b8646ff60c.jpg";